import React, { useState } from 'react';
import Paw from './Paw';

// Paw mark — renders a downloaded Figma PNG when present, otherwise the
// inline SVG fallback. The paw appears in two colors in the design (pink on
// the joystick handle, translucent-white on the tap circle), so each caller
// passes its own `src` + `fallbackColor`.
export default function PawMark({ src, className, fallbackColor = 'currentColor' }) {
  const [failed, setFailed] = useState(false);

  if (failed || !src) {
    return <Paw className={className} color={fallbackColor} />;
  }

  return (
    <img
      src={src}
      className={className}
      alt=""
      aria-hidden="true"
      onError={() => setFailed(true)}
      draggable={false}
    />
  );
}
